<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vLqB18/tc-custom/9780061749346.jpg?1731883558599" alt="This image is the cover for the book Pink Panther"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pink Panther
      </h1>
      <p class="bookDescription body article font2">
        <p>Oui, the mystery of the missing<br/>Pink Panther Diamond is as good as solved!<br/>Only one question remains:<br/>Who stole the Pink Panther Diamond?</p><p>A famous coach is murdered in a crowded stadium. His most-prized possession—a ring set with the stunning Pink Panther Diamond—has vanished in the melee. The French government needs a master detective on the case, but the head of the Paris Police Bureau is unwilling to jeopardize his chances for the Medal of Honor with such a difficult, high-profile assignment. Surely Inspector Jacques Clouseau, a clumsy provincial gendarme with a knack for ignoring the obvious, could fill in without upstaging his superiors. Within seconds he proves his genius by narrowing the list down to just 60,000 suspects!</p><p>Pink Panther fans know Clouseau will recover the missing gem, bring a killer to justice, restore a Republic's damaged pride, and win the gratitude of an adoring nation. And he'll attempt to beguile the beautiful singer rumored to be at the center of the whole felonious affair. But the real mystery is how the bumbling detective will actually do it!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Max Allan Collins
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Max Allan Collins is a Mystery Writers of America Grand Master. He is the author of the Shamus Award-winning Nathan Heller thrillers and the graphic novel &amp;lt;em&amp;gt;Road to Perdition&amp;lt;/em&amp;gt;, basis of the Academy Award-winning film starring Tom Hanks. His innovative Quarry novels led to a 2016 Cinemax series. He has completed a dozen posthumous Mickey Spillane mysteries, and wrote the syndicated &amp;lt;em&amp;gt;Dick Tracy&amp;lt;/em&amp;gt; series for more than fifteen years. His one-man show, &amp;lt;em&amp;gt;Eliot Ness: An Untouchable Life&amp;lt;/em&amp;gt;, was an Edgar Award finalist. He lives in Iowa.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c1c44f7